<template>
  <Page :title="title" style="background:white;">
    <div  class="details_v"  style="padding-bottom:1rem;"  ref="CC">


      <div class="van-collapse-item__content "  >
                            <!-- 课程名称 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程名称：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[0]['name']"
                            placeholder="请输入课程名称"
                            maxlength="100"
                            disabled="true"
                        >
                    </div>
                    <!-- 课程类型 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(1)">
                            {{pullList[1]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 导师类型 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">导师类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(2)">
                            {{pullList[2]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                     <!-- 培训导师 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">培训导师：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(3)">
                            {{pullList[3]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 课程日期 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active">
                        <div class="birthday-flex-style-one titles">课程日期:</div>
                        <div class="birthday-flex-style-one " @click="downSelections(4)">
                            {{pullList[4]['val']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                        <div>-</div>
                        <div class="birthday-flex-style-one" @click="downSelections(5)">
                            {{pullList[5]['val']||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 日期列表 -->
                    <div class="flex itemCenter cell-list-item cell-list-item-active"
                    v-for="(item,index)  in  U_RangeTimeList" v-bind:key="index" >
                        <!-- <div class="birthday-flex-style-one">课程日期</div> -->
                        <div class="birthday-flex-style-one  birthday-flex-style-one-ative" @click="downTimetions(index,1)">
                            {{item.date||'请选择'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                        <div class="birthday-flex-style-one birthday-flex-style-one-ative" @click="downTimetions(index,2)">
                            {{item.timeFrame==1?'上午':item.timeFrame==2?'下午':item.timeFrame==3?'全天':'上午'||'上午'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 添加日期 -->
                    <div class="flex itemCenter cell-list-item  center-flex" v-if="''"  @click="addDate" >
                               +
                    </div>

                    <!-- 国家 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">国家：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(6)">
                            {{pullList[6]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 城市 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">城市：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(7)">
                            {{pullList[7]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                    <!-- 地点 -->
                    <div class="flex itemCenter cell-list-item-feed addres-flex-cell">
                        <div class="input-title">地点：</div>
                        <div class="addres-flex feed"  style="  height: auto;min-height:0.6rem;" >
                          {{pullList[8]['name']}}
                        </div>
                    </div>
                    <!-- 学员类型 -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">学员类型：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(9)">
                            {{pullList[9]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                                v-if="''"
                            >
                        </div>
                    </div>
                            <!-- 学员人数 -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">学员人数：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[10]['name']"
                            placeholder="请输入学员人数"
                            maxlength="50"
                        >
                    </div>
                      <!-- 课程费用币种： -->
                     <div class="flex itemCenter cell-list-item">
                        <div class="input-title">课程费用币种：</div>
                        <div class="pull-down-selects" data-id="10" @click="downSelections(11)">
                            {{pullList[11]['name']||'全部'}}
                            <img
                                :src="require('@/assets/img/uparrow.png')"
                                class="uparrow"
                                alt=""
                                srcset=""
                            >
                        </div>
                    </div>
                            <!-- 单人费用： -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">单人费用：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[12]['name']"
                            placeholder="请输入单人费用"
                            maxlength="50"
                            disabled="true"
                        >
                    </div>
                            <!-- 费用合计： -->
                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">费用合计：</div>
                        <input
                            type="text"
                            class="inputs"
                            v-model="pullList[13]['name']"
                            placeholder="请输入费用合计"
                            maxlength="50"
                            disabled="true"
                        >
                    </div>


                    <div class="flex itemCenter cell-list-item">
                        <div class="input-title">提交作品：</div>
                        <div  class="radio-flex">
                        <van-radio-group v-model="pullList[14]['value']" disabled class="neededShow-flex">
                          <van-radio name="1"   >需要
                                          <img
                                          slot="icon"
                                          slot-scope="props"
                                          :src="props.checked ? Icon[0]: Icon[1]"
                                          class="radioImg"
                                        >
                          </van-radio>
                          <van-radio name="0"  >不需要
                                          <img
                                          slot="icon"
                                          slot-scope="props"
                                          :src="props.checked ? Icon[0]: Icon[1]"
                                          class="radioImg"
                                        >
                          </van-radio>
                        </van-radio-group>
                        </div>
                    </div>
      <div class="quillcontent">
        <!-- 富文本 -->
        <div class="show-title">课程介绍</div>
        <quill-editor
          :content="content"
          class="ql_editor"
          :options="editorOption"
        ></quill-editor>
      </div>
      <div class="show-title">课程时间范围</div>
      <div
        class="curriculum_time"  v-for="(items,index)  in calendarLists">{{items.timeFrame}}:{{items.date}}
      </div>
<div class="vant-collapse-flex">
  <van-collapse v-model="activeNames_one">
  <van-collapse-item :title="'课程成员'+ '('+totalRow+')'" name="1"  style="padding:0" >
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多的数据了"
          loading-text="正在加载数据"
          error-text="加载失败请重试"
          @load="onLoad"
          ref="adQ"
          :immediate-check="false"
        >
     <div class="member-list">
       <div class="memberList-item" v-for="(item,index) in memberList "   v-bind:key="index" >
          <div class="flex flexR" @click="toClientDetail(item.accountId)">
               <div class="first-items">姓名：{{item.name}}</div>
               <div class="last-items">性别：{{item.genderName || ""}}</div>
          </div>

          <div  class="flex flexR">
                <div class="first-items" @click="toClientDetail(item.accountId)"></div>
                <div class="last-items active" @click="lookProduction(item.courseMemberId,item.reviewUserId)">{{item.uploadedShow==1?'查看作品':''}}</div>
          </div>
       </div>
     </div>
  </van-list>
  </van-collapse-item>
  </van-collapse>
  </div>

            <!-- 下拉筛选 -->
            <van-popup v-model="showDownSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection"
                    @cancel="onCancelCode"
                    @confirm="onConfirmCode"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
            <!-- 时间筛选 -->
            <van-popup v-model="showTimeSelection" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="onCancelTime"
                @confirm="onConfirmTime"
                :min-date="minDate"
              />
            </van-popup>


                       <!-- 下拉筛选 -->
            <van-popup v-model="showDateSelection" position="bottom" :overlay="true">
                <van-picker
                    show-toolbar
                    title=""
                    :columns="downSelection1"
                    @cancel="onCancelCode1"
                    @confirm="onConfirmCode1"
                     :value-key="'name'"
                    class="van-picker-li"
                />
            </van-popup>
            <!-- 时间筛选 -->
            <van-popup v-model="showDateTime" position="bottom" :overlay="true">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                @cancel="onCancelTime1"
                @confirm="onConfirmTime1"
                :min-date="minDate"
              />
            </van-popup>
      </div>

      <!-- 底部按钮 -->
      <div class="bottom-button" v-if="statusButton==1 && hasModifyAuth">
          <div class="div1" @click="cancelClass">取消课程</div>
          <div class="div2" @click="changeTo">修改课程</div>
      </div>


  <van-dialog
  v-model="showcancel"
  show-cancel-button
  :before-close="beforeClose"
>
  <van-field
    v-model="cancelCause"
    type="textarea"
    placeholder="请输入取消原因"
  />
</van-dialog>
  <div class="returnTo">
    <img :src="require('@/assets/return.png')"   @click="returnTo"  class="back"  alt="">
  </div>
  </div>
  </Page>
</template>

<script>
import $api from "../../api/lkcollege_api"; // 接口
import { Dialog, Toast } from "vant";
import $  from 'jquery';
export default {
  name: "detailsCurriculum",
  data() {
    return {
      content:'',
        editorOption: {},
      title: "课程详情",
      memberList: [], //学员列表
      calendarList: [],
      height:0,






      ///////////////////////////-   重置  -////////////////////////////////
    activeNames_one:['0'],
    totalRow:0,
    calendarLists: [
        { timeFrame: "全天", date: "10:00-17:00" },
        { timeFrame: "上午", date: "10:00-13:00" },
        { timeFrame: "下午", date: "14:00-17:00" }
      ],
    minDate: new Date(),
    currentDate: new Date(),
    // 字典表查询code
    codeList:['teacherType','StudentType','Classes','Country','CourseCity','Currency','U_RangeTime'],
    teacherTypeList:[], //导师类型
    studentTypeList:[], //学员类型
    courseTypeList:[],  //全部课程
    CountryList:[],     //国家
    CourseCityList:[],  //城市
    CurrencyList:[],    //币种
    supervisorList:[],  //培训导师
    NeedList:[{name:"全部",value:"0"},{name:"需要",value:"1"},{name:"不需要",value:"2"},],        //提交作品

    courseType:"",   //课程类型
    teacherType:"",  //导师类型
    studentType:"",  //学员类型
    courseName:"",   //课程名称
    teacherId:"",    //培训导师
    startDate:"",    //课程开始日期
    endDate:"",      //课程结果日期
    city:"",         //城市
    startStudentCnt:"",  //学员开始人数
    endStudentCnt:"",    //学员结束人数
    currency:"",         //课程费用币种
    startPrice:"",       //单人费用开始费用
    endPrice:"",         //单人费用结束费用
    startAmount:"",      //费用合计开始
    endAmount:"",        //费用合计结束
    neededShow:"",       //是否需要提交作品
    address:"",          //地点
    country:"",          //国家
    pullList: [
        {name:"",val:""}, //课程名称
        {name:"",val:""}, //课程类型
        {name:"",val:""}, //导师类型
        {name:"",val:""}, //培训导师
        {name:"",val:""}, //课程开始日期
        {name:"",val:""}, //课程结果日期
        {name:"",val:""}, //国家
        {name:"",val:""}, //城市
        {name:"",val:""}, //地点
        {name:"",val:""}, //学员类型
        {name:"",val:""}, //学员开始人数
        {name:"",val:""}, //课程费用币种
        {name:"",val:""}, //单人费用开始费用
        {name:"",val:""}, //费用合计开始
        {name:"",val:"",value:""}, //是否需要提交作品
      ],
    showDownSelection:false ,  //下拉菜单展示
    showTimeSelection:false,   //下拉时间栏
    showDateSelection:false,   // 日期新增列表 下拉菜单展示
    showDateTime:false,        // 日期新增列表 下拉时间栏
    downSelection:[],          //下拉菜单列表数据
    downSelectionVal:0,        //下拉菜单当前索引
    U_RangeTime:[],            //筛选列表
    U_RangeTimeList:[],         //新增时间列表
    downTimeVal:0,             //时间列表下拉筛选
    downTimeType:0,            //点击新增时间列表判断 日期 和 时间段
    downSelection1:[],         // 新增时间 下拉列表
    courseId:"",               // 课程ID 来判断是否是编辑页面 默认为新增页面
    pageNumber:1,
    pageSize:10,
    loading:false,
    finished:false,
    statusButton:0,        //判断那妞  1 正常  0不显示
    showcancel:false,      //取消课程
    cancelCause:"",        //取消原因
    Icon:[ require('@/assets/Sc.png'),require('@/assets/Sn.png')],
    hasModifyAuth : true, //是否有修改权限
    };
  },
  methods: {
    onEditorFocus(val, editor) {
      // 富文本获得焦点时的事件
      console.log(editor); // 富文本获得焦点时的内容
      val.enable(false); // 在获取焦点的时候禁用
    },
    //查询课程详情信息
    async find_details(salesId, courseId) {
      try {
        let { sendSync, get } = this.$api;
        let data = await get("api/course/detail", {
          salesId,
          courseId
        });
        //查询失败
        if (!data.success) {
          Toast(data.msg);
          return;
        }
        let { courseModel, memberList, calendarList } = data.data;
        courseModel.rangeTime = JSON.parse(courseModel.rangeTime);
        this.memberList = memberList.list;
        this.calendarList = calendarList; //课程时间
        for (const key in courseModel) {
          this.courseModel[key] = courseModel[key];
        }
        console.log(this.courseModel);
      } catch (error) {
        console.log(error);
        Toast("发生错误");
      }
    },
    async selectTime() {
      try {
        console.log("下拉选择时间");
      } catch (error) {
        console.log(error);
        Toast("发生错误");
      }
    },
    async beforeClose(Dialog_, done) {
      try {
        this.cancelNotesshow = true;
        let { sendSync, get } = this.$api;
        if (Dialog_ != "confirm") {
          done();
          this.cancelNotes = null;
          return;
        }
        //取消备注必填
        if (!this.cancelNotes) {
          Toast("取消备注为必填");
          done(false);
          return;
        }
        done();
        let toast = Toast.loading({
          duration: 0, // 持续展示 toast
          forbidClick: true, // 禁用背景点击
          loadingType: "spinner",
          message: "取消成功"
        });
        //取消课程接口
        let cancel = await get("api/course/cancel", {
          salesId: this.$wxuserUtil.getUserId(),
          courseId: this.courseModel.courseId,
          cancelNotes: this.cancelNotes
        });
        //取消失败
        if (!cancel.success) {
          Toast(cancel.msg);
          return;
        }
        let second = 3;
        let timer = setInterval(() => {
          second--;
          if (second) {
            toast.message = `取消成功`;
          } else {
            clearInterval(timer);
            Toast.clear();
            this.cancelNotes = null;
            this.$router.push({
              path: "/listCurriculum",
              query: {}
            });
          }
        }, 1000);
        // console.log(data);
      } catch (error) {
        if (error == "cancel") {
          Toast("您已取消");
          return;
        }
        Toast(error.message);
      }
    },
    //取消课程
    async cancelCurriculum() {
      try {
        this.cancelNotesshow = true;
      } catch (error) {
        Toast(error.message);
      }
    },
    //修改
    async addCurriculum() {
      try {
        this.$router.push({
          path: "/addCurriculum",
          query: { edite: true, courseId: this.courseModel.courseId }
        });
      } catch (error) {
        Toast(error.message);
      }
    },





   /**
     *
     * =====================================================================================
     *                                        重置
     * =====================================================================================
     *
     */
   onLoad(){
     setTimeout(() => {
       this.pageNumber=parseInt(this.pageNumber+1)
       this.getCourseDetails(2,this.pageNumber,this.courseId)
     }, 500);
   },
    // 新增日期
   addDate(){
         this.U_RangeTimeList.push({"date": "","timeFrame": ""})

    },
   onCancelCode1(){
       this.showDateSelection=false;
   },
   onConfirmCode1(val){
       console.log("确认框",val)
       this.U_RangeTimeList[this.downTimeVal]['timeFrame']=val.value?val.value:1;
       this.showDateSelection=false;
   },
   onCancelTime1(){
       this.showDateTime=false;
   },
   onConfirmTime1(val){
       console.log("时间确认返回")
       this.U_RangeTimeList[this.downTimeVal]['date']=this.$time(val);
       this.showDateTime=false;
   },
    //添加课程
   addCurriculum() {
     let $data   =  this.pullList;
          console.log(document.getElementsByClassName('ql-editor')[0],'富文本内容')
      if($data[0]['name']==''||$data[0]['name']==null){
       this.$title("课程名称不能为空")
       return;
      }
      if($data[1]['value']==''||$data[1]['value']==null){
       this.$title("请选择课程类型")
       return;
      }
      if($data[2]['value']==''||$data[2]['value']==null){
       this.$title("请选择导师类型")
       return;
      }
      if($data[3]['value']==''||$data[3]['value']==null){
       this.$title("请选择培训导师")
       return;
      }

      if($data[4]['name']==''||$data[5]['name']==''){
       this.$title("请选择日期")
       return;
      }else{
        if(this.compareDate($data[4]['name'],$data[5]['name'])==false){
          this.$title("开始日期大于结束日期")
          return;
        }
      }

      if(this.U_RangeTimeList.length==0){
       this.$title("请添加课程日期")
       return;
      }

      for(let o=0;o<this.U_RangeTimeList.length;o++){
            if(this.U_RangeTimeList[o]['date']==''){
                     this.$title("添加课程日期不能为空")
                     return;
            }else{
               if(this.U_RangeTimeList[o]['timeFrame']==''){
                      this.U_RangeTimeList[o]['timeFrame']=1;
               }
            }
      }

      if($data[6]['value']==''||$data[6]['value']==null){
       this.$title("请选择国家")
       return;
      }
      if($data[7]['value']==''||$data[7]['value']==null){
       this.$title("请选择城市")
       return;
      }
      if($data[8]['name']==''||$data[8]['name']==null){
       this.$title("请选择详细地址")
       return;
      }
      if($data[9]['value']==''||$data[9]['value']==null){
       this.$title("请选择学员类型")
       return;
      }
      if($data[10]['name']==''||$data[10]['name']==null){
       this.$title("学员人数不能为空")
       return;
      }
      if($data[11]['value']==''||$data[11]['value']==null){
       this.$title("请选择费用币种")
       return;
      }
      if($data[12]['name']==''||$data[12]['name']==null){
       this.$title("单人费用不能为空")
       return;
      }
      if($data[13]['name']==''||$data[13]['name']==null){
       this.$title("费用合计不能为空")
       return;
      }
      if($data[14]['value']==''||$data[14]['value']==null){
       this.$title("请选择提交作品需求")
       return;
      }

     console.log("获取数据列表",this.pullList)
     console.log("时间列表",this.U_RangeTimeList)


     let data={}
              data['salesId']=this.$wxuserUtil.getUserId();
              data['courseType']=$data[1]['value'];            //课程类型
              // data['teacherType']=$data[2]['value'];        //导师类型
              data['studentType']=$data[9]['value'];           //学员类型
              data['courseName']=$data[0]['name'].trim();             //课程名称
              data['teacherId']=$data[3]['value'];             //培训导师
              data['startDate']=$data[4]['name'].trim();              //课程开始日期
              data['endDate']=$data[5]['name'].trim();                //课程结果日期
              data['city']=$data[7]['value'];                  //城市
              data['studentCnt']=$data[10]['name'];            //学员开始人数
              data['currency']=$data[11]['value'];             //课程费用币种
              data['price']=$data[12]['name'];                 //单人费用开始费用
              data['amount']=$data[13]['name'];                //费用合计开始
              data['neededShow']=$data[14]['value'];                //是否需要提交作品
              data['address']=$data[8]['name'];                     //详细地址
              data['country']=$data[6]['value'];                     //国家
              data['deptId']=this.$wxuserUtil.getDeptId();          //门店ID
              data['timeList']= JSON.stringify(this.U_RangeTimeList);                //时间列表
              data['rangeTime']= $data[4]['name'].trim()+'/'+$data[5]['name'].trim();
              this.$api.saveCourseSaves(data).then(Response=>{
             console.log("新增成功",Response)
             if(Response.success){
               this.$title("新增成功 courseId")
               setTimeout(()=>{
                this.$router.push({ path: "/detailsCurriculum", query: {courseId:Response.data} });
               },500)
             }else{
               this.$title("新增失败")
             }
     })

  },
    //计算最大值最小资
  MaxMin(data){
    let list=[];
    for(let i=0;i<data.length;i++){
      list.push(this.moment(data[i]['date'],'YYYY-MM-DD'))
    }
      this.pullList[4]['name']=this.moment.min(list)['_i'];
      this.pullList[5]['name']=this.moment.max(list)['_i'];
  },
  compareDate(checkStartDate, checkEndDate) {
    var arys1= new Array();
    var arys2= new Array();
    if(checkStartDate != null && checkEndDate != null) {
        arys1=checkStartDate.split('-');
          var sdate=new Date(arys1[0],parseInt(arys1[1]-1),arys1[2]);
        arys2=checkEndDate.split('-');
        var edate=new Date(arys2[0],parseInt(arys2[1]-1),arys2[2]);
    if(sdate > edate) {
        return false;
    }  else {
        return true;
        }
     }
  },



    // 拉下    确定 取消
    onCancelCode(){ this.showDownSelection=false; },
    onConfirmCode(val){
         this.pullList[this.downSelectionVal]['name']=val.name;
         this.pullList[this.downSelectionVal]['value']=val.value;
         this.showDownSelection=false;
         if(this.downSelectionVal==2){
          this.getCourseTeacherInfo(this.pullList[this.downSelectionVal]['value']);
         }
    },
    // 时间    确定 取消
    onCancelTime(){ this.showTimeSelection=false; },
    onConfirmTime(val){
           if(this.downSelectionVal!=98){
            this.pullList[this.downSelectionVal]['name']=this.$time(val);
            this.pullList[this.downSelectionVal]['value']=this.$time(val);
            this.showTimeSelection=false;
           }
    },
    downSelections(index){
      this.downSelectionVal=index;
      if(index==1||index==2||index==3||index==6||index==7||index==9||index==11){
        switch(index){
          case   1     :    this.downSelection=this.setCodeAlls(this.courseTypeList);break
          case   2     :    this.downSelection=this.setCodeAlls(this.teacherTypeList);break
          case   3     :    this.downSelection=this.setCodeAlls(this.supervisorList);break
          case   6     :    this.downSelection=this.setCodeAlls(this.CountryList);break
          case   7     :    this.downSelection=this.setCodeAlls(this.CourseCityList);break
          case   9     :    this.downSelection=this.setCodeAlls(this.studentTypeList);break
          case   11    :    this.downSelection=this.setCodeAlls(this.CurrencyList);break
        }
        this.showDownSelection=true;
      }else
      if(index==99){
        this.downSelection=this.U_RangeTime;
        this.showDownSelection=true;
      }else{
        this.showTimeSelection=true;
      }
    },
    downTimetions(index,ID){
      return;
        this.downTimeType=ID;
        this.downTimeVal=index;
        if(ID==1){
                this.showDateTime=true;
        }else{
                this.showDateSelection=true;
                this.downSelection1=this.U_RangeTime;
        }
    },
    getQueryByTcode() {
      for (let i = 0; i < this.codeList.length; i++) {
        this.$api.getQueryByTcode({ tcode: this.codeList[i] })
          .then(Response => {
            switch (this.codeList[i]) {
              case "Classes"                 :  this.courseTypeList = Response.data;break;
              case "teacherType"             :  this.teacherTypeList = Response.data;break;
              case "StudentType"             :  this.studentTypeList = Response.data;break;
              case "Country"                 :  this.CountryList = Response.data;break;
              case "CourseCity"              :  this.CourseCityList = Response.data;break;
              case "Currency"                :  this.CurrencyList = Response.data;break;
              case "U_RangeTime"             :  this.U_RangeTime = Response.data;break;
            }
          });
      }
    },
    // 查询导师
    getCourseTeacherInfo(ID){
      this.$api.getCourseTeacherInfo({salesId: this.$wxuserUtil.getUserId(),teacherType:ID}).then(Response=>{
           if(Response.success){
              for(let i=0;i<Response.data.length;i++){
                  Response.data[i]['value']= Response.data[i]['teacherId'];
              }
              this.supervisorList= Response.data;
           }
      })
    },
   /**
    *
    *   添加请选择
    *
    */
   setCodeAlls(data){
      if(Array.isArray(data)){
        return  [{name:"请选择",value:""}].concat(data);
      }else{
        return  [].concat(data);
      }
   },
  /**
   *
   *   课程详情   TP201903011655174044001
   *
   */
getCourseDetails(ID,Page,courseId){
       let data={};
           data['salesId']=this.$wxuserUtil.getUserId();
           data['courseId']=courseId;
           data['pageNumber']=Page;
           data['pageSize']=this.pageSize;

     var Response=   this.$api.getCourseDetails(data)
            if(Response.success){
              let result   =  Response.data;
              let courseModel  =  Response.data.courseModel;
              console.log("客户详情",courseModel)
              console.log("开始日期",courseModel.startDate)
              console.log("结束日期",courseModel.endDate)
               if(ID==1){
                    this.U_RangeTimeList=this.amendDataList(result.calendarList);
                    let $data =[];$data=this.pullList;
                    $data[0]['name']=courseModel.name;
                    $data[0]['val']=courseModel.name;
                    $data[1]['name']=courseModel.type;
                    $data[1]['val']=courseModel.typeDval;
                    $data[2]['name']=courseModel.teacherType;
                    $data[2]['val']=courseModel.teacherTypeDval;
                    $data[3]['name']=courseModel.teacherName;
                    $data[3]['val']=courseModel.teacherId;
                    $data[4]['name']=courseModel.startDate;
                    $data[4]['val']=courseModel.startDate;
                    $data[5]['name']=courseModel.endDate;
                    $data[5]['val']=courseModel.endDate;
                    $data[6]['name']=courseModel.country;
                    $data[6]['val']=courseModel.countryDval;
                    $data[7]['name']=courseModel.city;
                    $data[7]['val']=courseModel.city;
                    $data[8]['name']=courseModel.address;
                    $data[8]['val']=courseModel.address;
                    $data[9]['name']=courseModel.studentType;
                    $data[9]['val']=courseModel.studentTypeDval;
                    $data[10]['name']=this.$numeral(courseModel.sudentCnt).format('0,0');
                    $data[11]['val']=courseModel.currencyDval;
                    $data[11]['name']=courseModel.currency;
                    $data[12]['val']=courseModel.price;
                    $data[12]['name']=this.$numeral(courseModel.price).format('0,0.00');
                    $data[13]['val']=courseModel.amount;
                    $data[13]['name']=this.$numeral(courseModel.amount).format('0,0.00');
                    $data[14]['value']=courseModel.neededShow;
                    this.pullList=$data;
                    console.log("改变后得数组",this.pullList)
                    console.log("改变后得数组1",$data)
                    this.content=courseModel.descption;
                    this.memberList=result.memberList.list;
                    this.totalRow=result.memberList.totalRow;
                    this.statusButton=result.courseModel.status
                    this.MaxMin(this.U_RangeTimeList);
                    if(result.memberList.list.length==0||!result.memberList.list){
                      this.finished=true;
                    }

               }
               if(ID==2){
                      this.memberList=this.memberList.concat(result.memberList.list);
                      if(result.memberList.list.length==0||this.memberList.length>=this.totalRow){
                       this.finished=true;
                       this.loading=false;
                     }
               }

            }else{
              this.$title("请求异常")
            }
}
,
  //查看作品
   lookProduction(ID, index) {
      let lookProduction=false;
      if(index){
        lookProduction=true;
      }else{
        lookProduction=false;
      }
        this.$router.push({
          path: "/lookProduction",
          query: { lookProduction: lookProduction, ID,G:2,menuId:this.$parent.IdCode }
        });
    },
  // 返回上一级
  returnTo(){
    this.$router.push({ path: "/listCurriculum"})
  },
  //修改课程
  changeTo(){
        this.$router.push({
          path: "/addCurriculum",
          query: { courseId:this.courseId ,title:'修改课程'}
        });
  },
  //取消课程
  cancelClass(){
    this.showcancel=true;
  },
  beforeClose(action, done) {
      if (action === 'confirm') {
        setTimeout(done, 600);
        let data={};
         data['salesId']=this.$wxuserUtil.getUserId();
         data['courseId']=this.courseId;
         data['cancelNotes']=this.cancelCause
         if(this.cancelCause==''){
           this.$title('取消原因不能为空');
           return;
         }
         this.$api.cancelCourses(data).then(Response=>{
             if(Response.success){
                 this.$title("取消课程成功")
                  this.getCourseDetails(1,1,this.courseId);

             }else{
                 this.$title("取消课程失败")
             }
         })
      } else {
        done();
      }
    },
/**
 *
 *   修改返回数据结构
 *
 */
amendDataList(data){
  let $data=[];
   if(Array.isArray(data)){
       for(let i=0; i<data.length;i++){
          $data.push({"date":data[i]['date'],"timeFrame":data[i]['timeframeVal']})
       }

       return $data;
   }
},

   /**
     *   客户详情
     **/
    toClientDetail(ID){
      if(ID){
        this.$router.push({ path: "/ClientDetails", query: {custId:ID,showCC:true,IdCode:this.$parent.IdCode} })
      }
    },





  },
  mounted() {
    this.hasModifyAuth = this.$wxuserUtil.hasFunAuthByRoute(this.$route.path,this.$wxuserUtil.funcKey.Modified);
     document.getElementById('app').scrollTop =  0;
     $(":focus").blur()
     $('.van-cell-childs .van-cell').css({'padding':0})
    if(this.$phones==1){
     this.$refs.CC.style.height=localStorage.getItem('heights')-40+'px';
     }else{
     this.$refs.CC.style.height=localStorage.getItem('heights')-40+'px';
     }
  },
  created() {
    this.getQueryByTcode();
    if(this.$route.query.courseId){
         this.getCourseDetails(1,1,this.$route.query.courseId);
         this.courseId=this.$route.query.courseId;
    }
  },
  watch: {},
  components: {}
};
</script>
<style lang="less"  scoped src="~p/pageView-filter.less"></style>
<style lang="less" scoped>
.cell-list-item{
  min-height: 1.1rem;
  max-height: 1.5rem;
  overflow: hidden;
}
.cell-list-item-feed{
    min-height: 1.1rem;
    max-height: 1.5rem;
    overflow: hidden;
    padding: .1rem 0.3rem;
    margin-top: 0.15rem;
    background: #f6f6f6;
    height: auto;
}

.addres-flex-cell{
  max-height: 10rem;
}

.addres-flex{
      max-height: 10rem;
      width:6rem;
      text-align: center;
      position: relative;
      border: none;
      outline: none;
      background: #f6f6f6;
      // overflow: hidden;
      // text-overflow: ellipsis;
      /*display: -webkit-box;*/
      /*-webkit-line-clamp: 3;
      -webkit-box-orient: vertical; */
      min-height: 0.6rem;
      overflow-y: auto;
    // .feed{
    //     overflow: hidden;
    //     text-overflow: ellipsis;
    //     display: -webkit-box;
    //     -webkit-line-clamp: 2;
    //     -webkit-box-orient: vertical;  
    // }
}
.titles{
  color:#0d0d0d;
}
.details_v{
      overflow-y: auto;
  .van-collapse-item__title{
    height: auto;
    padding: 0px!important;
  }
}
.van-cell-childs{
.van-collapse-item__title,.van-cell{
      padding: 0px!important;
      /*height: auto;*/
}
}
.vant-collapse-flex{
  margin-top: .3rem;
  .van-collapse-item__content{
      padding: 0px!important;
      overflow-y: auto!important;
  }
}
.bottom-button{
  position: fixed;
  bottom: 0;
  width:100%;
  height: 40px;
  display: flex;
  flex-direction: row;
  div{
    width:50%;
    height:40px;
    line-height: 40px;
    text-align: center;
  }
  .div1{
    border:1px solid  #EF7074;
    color:#EF7074;
    background: #fff;
  }
  .div2{
    background: #E2050E;
    border:1px solid  #E2050E;
    color:#fff;
  }
}
.show-title{
  padding: 0px;
  margin-top: .3rem;
  margin-bottom: .3rem;
  font-size: .4rem;
  color: #000;
}
.list-auto{
  overflow-y: auto;
}
.van-list{
  margin-bottom: 1.5rem;
  .activeR{
    background: #1989FA;
  }
.quillcontent{
  margin: 0rem;
.ql_editor{
  width:100%;
}}}
.member-list{

  .first-items{
    width:4rem;
  }
  .active{
    color:red;
    font-weight: bold;
  }

      .last-items{
        margin-left: 1.5rem;
      }
      .memberList-item{
    height: 2rem;
    line-height: 1rem;
    background: #f4f4f4;
    margin-top: .2rem;
    border-radius: .1rem;
    padding: 0 .3rem;
      }
}











.center-flex{
  -ms-flex-item-align: center;
  align-items: center;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  font-size:.4rem;
}
.van-list{
.birthday-flex-style-one-ative{
  width:4.1rem;
}
}
.birthday-flex-style-one{
   flex: .495
}
.radio-flex{
  display: flex;
  flex-direction: row;
  justify-content:space-around;
  width:5rem;
  .neededShow-flex{
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    width:100%;
    .van-radio{
      padding-bottom: .1rem;
    }
  }
}
.content {
  padding-bottom: 1rem;
  background: white;
  overflow: hidden;
}
.content_div {
  .van-field__label {
    width: 3rem;
  }
}

.group,
.radio_group {
  margin: 0.1rem auto;
  width: 95%;
  margin-bottom: 1rem;
  border: none;
  background: #fdfbfb;
  position: static;
  .van-cell {
    background: #fdfbfb;
  }
}
.radio_group-flex {
  margin-top: 0.15rem;
}
.content_div {
  margin-top: 0.15rem;
  padding: 0rem 0.3rem;
}
.botton_but {
  position: fixed;
  bottom: 0;
  width: 100%;
}
.addbutton {
  width: 100%;
  display: block;
  margin: 0 auto;
  text-align: center;
  height: 1.2rem;
}
.genderRadio-flex {
  .van-radio-group {
    display: flex;
    width: 4rem;
    flex-direction: row;
    justify-content: space-between;
    //  margin: .5rem auto;
    font-size: 0.3rem;
  }
}
.content_div > li > .van-cell__right-icon {
  color: #c0c4cc;
  font-size: 14px;
  transition: transform 0.3s;
  transform: rotateZ(90deg);
  cursor: pointer;
}
.quillcontent {
  margin-bottom: 2rem;
}
.ql_editor {
  height: 100%;
  width: 95%;
  margin: 0 auto;
}
.van-cell__value {
  text-align: left;
  color: #323233;
}
.add-button {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  font-weight: bold;
  // color: #e10913;
  background: white;
  border: 1px solid #ffffff;
  border-radius: 0.1rem;
}
.delete {
  display: inline-block;
  border-radius: 50%;
  color: red;
  width: 10px;
  height: 10px;
  line-height: 10px;
  border: 1px solid red;
}
.van-cell--required {
  background: rgb(246, 246, 246);
}
.van-cell-group-flex {
  height: 1.2rem;
  border: none;
  background: #fdfbfb;
  position: static;
  .van-cell {
    padding: 0.3rem 0.3rem;
    background: #fdfbfb;
    border: none;
  }
}
.rowcontent-item {
  -ms-flex-item-align: center;
  align-items: center;
  padding-left: 0.3rem;
}
.rowcontent {
  margin-top: 0.15rem;
  width: 100%;
  background: #fdfbfb;
  text-align: left;
  -ms-flex-item-align: center;
  align-items: center;
  height: 1rem;
  line-height: 1rem;
  font-size: 16px;
}
.downimg {
  position: absolute;
  right: 0.2rem;
  width: 0.3rem;
  height: 0.3rem;
  margin-top: -0.6rem;
}
.downimgdate {
  width: 0.3rem;
  height: 0.3rem;
}
.rowinput {
  height: 0.9rem;
  background-color: #f6f6f6;
  color: rgba(13, 13, 13, 1);
  font-size: 14px;
  text-align: left;
  border: none;
}
.item-flex {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  -ms-flex-item-align: center;
  align-items: center;
}
.returnTo{
  width:1rem;
  height:1rem;
  position:fixed;
  z-index: 10;
  bottom: 3rem;
  right: 0.3rem;
  background-color: #fff;
  border-radius: 50%;

  img{
    width:100%;
    height:100%;
    border-radius: 50%;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/lkcollege/details.vue